import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
// import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { TextContainer, Image, DisplayText } from '../components'
import styles from 'assets/scss/views/Auth.scss'
import defaultPropertyImage from './../assets/images/defaultPropertyImage.png'
import * as translationService from '../services/translationService'

const mapStateToProps = state => {
  const { AuthReducer } = state
  const { user = {}, error } = AuthReducer
  const { mobileNumber, id } = user
  return {
    mobileNumber,
    id,
    error,
  }
}

class ConfirmEmailSuccessView extends React.Component {
  static propTypes = {
    property: PropTypes.any,
  }

  render() {
    return (
      <div className={styles.Auth}>
        <div className={styles.Text}>
          <TextContainer>
            <DisplayText>{translationService.verificationEmailTitle()}</DisplayText>
            <p>{translationService.verificationEmailMessage()}</p>
            <p>{translationService.closeWindow()}</p>
          </TextContainer>
        </div>
        <div className={styles.Image}>
          <Image source={defaultPropertyImage} />
        </div>
      </div>
    )
  }
}

export default compose(
  translate('translations'),
  connect(mapStateToProps),
)(ConfirmEmailSuccessView)



// WEBPACK FOOTER //
// ./src/views/ConfirmEmailSuccessView.js